import Page from "../../pages/Page";
import Logo from "../../assets/mindstack-logo.png";
import Button from "../input/button";
import { Typography } from "@mui/material";

const ErrorFallback = ({ error }) => {
  return (
    <div className="error-page">
      <div className="error-fallback">
        <img
          className="error-logo"
          src={Logo}
          onClick={() => window.location.replace("/")}
        />
        <Typography variant="h1WhiteNoMargin" className="error-header">
          Something went wrong 😔
        </Typography>
        <Typography variant="body1White" className="error-description">
          There has been a problem and Mindstack has crashed
        </Typography>
        <Typography variant="body1White" className="error-description">
          You can try reloading the page to see if that fixes the issue.
        </Typography>
        <Typography
          variant="body1White"
          className="error-description"
          style={{ marginTop: "32px", marginBottom: "32px" }}
        >
          Mindstack is still in development. If you could take a second to
          report the issue we would really appreciate it.
        </Typography>

        <Button
          color="orange"
          size="huge"
          text="Report issue"
          onClick={() => window.location.replace("/feedback")}
        />
        <div style={{ marginTop: "16px" }} />
        <Button
          color="green"
          size="huge"
          text="Home"
          onClick={() => window.location.replace("/")}
        />
      </div>
    </div>
  );
};

export default ErrorFallback;
